import getRequest from '../../../../getRequest';

/**
 * Get all Site Categories for the given site id from PRISM db.
 *
 * @param {number} siteId
 * @returns {[
 *   {
 *     categoryId: number,
 *     name: string,
 *     hierarchy: string
 *   }
 * ]}
 */
function getCategories(siteId) {
  const endpoint = `/oc-product/v1/sites/${siteId}/categories`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get Categories')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default getCategories;
